{
	"en-US": {
		"home": "/petition-guides",
		"createPetition": "/petition-guides/create-a-petition",
		"sharePetition": "/petition-guides/share-your-petition",
		"buildMomentum": "/petition-guides/build-momentum",
		"reachMedia": "/petition-guides/media",
		"engageDecisionMaker": "/petition-guides/engage-decision-makers",
		"declareVictory": "/petition-guides/declare-petition-victory"
	},
	"en-CA": {
		"home": "/petition-guides",
		"createPetition": "/petition-guides/create-a-petition",
		"sharePetition": "/petition-guides/share-your-petition",
		"buildMomentum": "/petition-guides/build-momentum",
		"reachMedia": "/petition-guides/media",
		"engageDecisionMaker": "/petition-guides/engage-decision-makers",
		"declareVictory": "/petition-guides/declare-petition-victory"
	},
	"en-IN": {
		"home": "/petition-guides",
		"createPetition": "/petition-guides/create-a-petition",
		"sharePetition": "/petition-guides/share-your-petition",
		"buildMomentum": "/petition-guides/build-momentum",
		"reachMedia": "/petition-guides/media",
		"engageDecisionMaker": "/petition-guides/engage-decision-makers",
		"declareVictory": "/petition-guides/declare-petition-victory"
	},
	"en-AU": {
		"home": "/petition-guides",
		"createPetition": "/petition-guides/create-a-petition",
		"sharePetition": "/petition-guides/share-your-petition",
		"buildMomentum": "/petition-guides/build-momentum",
		"reachMedia": "/petition-guides/media",
		"engageDecisionMaker": "/petition-guides/engage-decision-makers",
		"declareVictory": "/petition-guides/declare-petition-victory"
	},
	"en-GB": {
		"home": "/petition-guides",
		"createPetition": "/petition-guides/create-a-petition",
		"sharePetition": "/petition-guides/share-your-petition",
		"buildMomentum": "/petition-guides/build-momentum",
		"reachMedia": "/petition-guides/media",
		"engageDecisionMaker": "/petition-guides/engage-decision-makers",
		"declareVictory": "/petition-guides/declare-petition-victory"
	},
	"de-DE": {
		"home": "/l/de/p/kampagnentraining",
		"createPetition": "/l/de/p/petition-starten",
		"sharePetition": "/l/de/p/kampagne-verbreiten",
		"buildMomentum": "/l/de/p/erfolg-ausbauen",
		"reachMedia": "/l/de/p/massenmedien-nutzen",
		"engageDecisionMaker": "/l/de/p/entscheidungstraegerinnen-kontaktieren",
		"declareVictory": "/l/de/p/erfolg-erklaeren"
	},
	"es-ES": {
		"home": "/petition-guides",
		"createPetition": "/petition-guides/create-a-petition",
		"sharePetition": "/petition-guides/share-your-petition",
		"buildMomentum": "/petition-guides/build-momentum",
		"reachMedia": "/petition-guides/media",
		"engageDecisionMaker": "/petition-guides/engage-decision-makers",
		"declareVictory": "/petition-guides/declare-petition-victory"
	},
	"es-419": {
		"home": "/petition-guides",
		"createPetition": "/petition-guides/create-a-petition",
		"sharePetition": "/petition-guides/share-your-petition",
		"buildMomentum": "/petition-guides/build-momentum",
		"reachMedia": "/petition-guides/media",
		"engageDecisionMaker": "/petition-guides/engage-decision-makers",
		"declareVictory": "/petition-guides/declare-petition-victory"
	},
	"es-AR": {
		"home": "/petition-guides",
		"createPetition": "/petition-guides/create-a-petition",
		"sharePetition": "/petition-guides/share-your-petition",
		"buildMomentum": "/petition-guides/build-momentum",
		"reachMedia": "/petition-guides/media",
		"engageDecisionMaker": "/petition-guides/engage-decision-makers",
		"declareVictory": "/petition-guides/declare-petition-victory"
	},
	"fr-FR": {
		"home": "/petition-guides",
		"createPetition": "/petition-guides/create-a-petition",
		"sharePetition": "/petition-guides/share-your-petition",
		"buildMomentum": "/petition-guides/build-momentum",
		"reachMedia": "/petition-guides/media",
		"engageDecisionMaker": "/petition-guides/engage-decision-makers",
		"declareVictory": "/petition-guides/declare-petition-victory"
	},
	"hi-IN": {},
	"id-ID": {},
	"it-IT": {
		"home": "/petition-guides",
		"createPetition": "/petition-guides/create-a-petition",
		"sharePetition": "/petition-guides/share-your-petition",
		"buildMomentum": "/petition-guides/build-momentum",
		"reachMedia": "/petition-guides/media",
		"engageDecisionMaker": "/petition-guides/engage-decision-makers",
		"declareVictory": "/petition-guides/declare-petition-victory"
	},
	"ja-JP": {
		"home": "/l/jp/guide00-home",
		"createPetition": "/l/jp/guide02",
		"sharePetition": "/l/jp/guide03",
		"reachMedia": "/l/jp/guide05",
		"engageDecisionMaker": "/l/jp/guide06",
		"declareVictory": "/l/jp/guide07"
	},
	"ko-KR": {},
	"pt-BR": {},
	"ru-RU": {},
	"th-TH": {},
	"tr-TR": {
		"home": "/petition-guides",
		"createPetition": "/petition-guides/create-a-petition",
		"sharePetition": "/petition-guides/share-your-petition",
		"buildMomentum": "/petition-guides/build-momentum",
		"reachMedia": "/petition-guides/media",
		"engageDecisionMaker": "/petition-guides/engage-decision-makers",
		"declareVictory": "/petition-guides/declare-petition-victory"
	}
}
